import { Card, Chip } from "@mui/material";
import { MdAttachMoney, MdCircle, MdMonetizationOn, MdPanoramaFishEye, MdUndo } from "react-icons/md";
import Status from "../uteis/Status";

import { format, parse } from "date-fns"
import styled from "styled-components";
import { useEffect, useState } from "react";
import { marcaIntegracao } from "../../servicos/marcaIntegracao";

import icon from "./../../assets/icones/relogio.svg"

export const Marcador = styled.div`
	height: 1.5rem;
	display: flex;
	justify-content: center;
	align-items: safe center;
	font-size: 1rem;
	font-weight: 700;
	margin: 0.15rem 0.25rem 0.25rem 0;
`

export const GridInfos = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);   /* 6 colunas → base = 3 itens/linha */
  /* todo filho direto ocupa 2 colunas (≈ 33.33%) */
  & > * { grid-column: span 2; }

  /* Resto 1 (ex.: 4, 7 itens): último ocupa 100% */
  & > :nth-last-child(1):nth-child(3n + 1) {
    grid-column: 1 / -1;
  }

  /* Resto 2 (ex.: 5, 8 itens): dois últimos ocupam 50% cada */
  & > :nth-last-child(2):nth-child(3n + 1),
  & > :nth-last-child(1):nth-child(3n + 2) {
    grid-column: span 3;
  }
`;


export default function CardServico({ servico, setModal, obj, mostrarNomes, hideValue, action, corDinamica, onVerRota }) {
	const urgente = servico["s.urgente"] == "S"
	const economico = servico["s.freteExpresso"] != ""
	const marca = marcaIntegracao(servico)

	// --- montar itens dinamicamente (máx. 3 por linha) ---
	const itens = [];

	return <Card>
		{urgente && <div className="bg-red-500 text-white" style={{
			// margin: "-1rem",
			padding: "0.5rem 1rem"
		}}>
			<div className="flex items-center gap-2">
				<img src={icon} style={{
					height: "1.25rem",
					filter: "brightness(10)"
				}} alt="" />
				Serviço urgente
			</div>
		</div>}

		{economico && <div className="bg-cyan-500 text-white" style={{
			// margin: "-1rem",
			padding: "0.5rem 1rem"
		}}>
			<div className="flex items-center gap-2">
				<MdMonetizationOn size={24} />
				Serviço econômico
			</div>
		</div>}

		<div className={`p-3 bgGradientGrey ${urgente && 'text-danger'}`}>
			<div className="flex items-end justify-between flex-wrap mb-2">
				{/* Esquerda: ID e Chips */}
				<div className="flex items-end gap-2">
					<h4 style={{ fontSize: "1.3rem", fontWeight: 800 }} className="mb-0">
						#{servico['s.id']}
					</h4>
					<div className="flex gap-2 ">
						{servico["s.ifood"] && (
							<Chip
								label={marca.nome}
								size="small"
								sx={{ backgroundColor: marca.fundo, color: marca.texto }}
							/>
						)}
						{servico['s.dataHoraColetar'] && servico['s.dataHoraColetar'] !== '0000-00-00 00:00:00' && (
							<Chip color="warning" label="Agendado" size="small" />
						)}
						{servico['s.tipo'] == "AAI" && <Chip 
							label="AnotaAí" 
							size="small" 
							sx={{ 
								backgroundColor: 'rgb(56, 182, 255)', 
								color: 'white' 
							}} 
						/>}
					</div>
				</div>

				{/* Direita: Status */}
				<div className="flex justify-end">
					<Status texto={servico?.filtroLegenda ?? 'CONCLUIDO'} danger={urgente} />
				</div>
			</div>


			{servico["nome"] && <div className="mb-2">
				<div className="d-inline-block truncate small" style={{
					color: 'var(--primaria-darkest)'
				}}>
					<Chip label={<><b>Solicitante:</b> {servico["nome"]}</>} />

				</div>
			</div>}

			<div onClick={() => {
				if (setModal && obj) setModal(obj)
			}}>
				{servico.enderecos
					? <div>
						<div className="truncate" style={{
							color: 'var(--primaria-darkest)'
						}}>
							{servico.enderecos[0]['e.rua']}
						</div>
					</div>
					: <div className="text-center">
						Sem endereços
					</div>}

				<div>
					{servico.enderecos?.length == 2
						? <div className="truncate my-1" style={{
							color: 'var(--primaria-darkest)'
						}}>
							{servico.enderecos[1]['e.rua']}
						</div>
						: <><div xs="6" className="flex items-center opacity-50 truncate" style={{
							color: 'var(--primaria-darkest)'
						}}>
							<div className="small flex gap-2 items-center">
								{(servico.enderecos?.length - 1) > 1
									? <>
										<Marcador>
											+{servico.enderecos.length - 1}
										</Marcador>
										<div>
											Endereços
										</div>
									</> : ''}
							</div>
						</div>
							<div
								xs="6"
								className="flex items-center justify-end opacity-50"
							>
								{servico['s.retorno'] == 'S' && <div
									style={{ color: 'var(--primaria-darkest)' }}
									className="flex items-center gap-1 small">
									<MdUndo size="22" />
									Retorno ao 1º ponto
								</div>}
							</div>
						</>
					}
				</div>
			</div>

			{typeof onVerRota === "function" && (
				<div className="mt-1" onClick={(e) => e.stopPropagation()}>
					{onVerRota(servico)}
				</div>
			)}

			{servico.tempoColetarSegundosFalta && <TimerColeta label={servico.tempoColetarMsg} tempoInicial={servico.tempoColetarSegundosFalta} tempoMax={servico.tempoMax} />}

			{!hideValue && <GridInfos className="mt-2 gap-1">
				{(servico['s.valorProfissional'] || servico['s.valor']) && <div className="truncate grid-item">
					<Status
						danger={urgente}
						texto={new Intl.NumberFormat('pt-BR', {
							style: 'currency',
							currency: 'BRL'
						}).format(servico['s.valorProfissional'] ?? servico['s.valor'])}
						fill={true}
					/>
				</div>}

				{servico['s.distancia'] != ''
					&& servico['s.distancia'] != null
					&& servico["s.distancia"] != "-"
					&& <div className="truncate grid-item">
						<Status
							danger={urgente}
							texto={
								(servico['s.distancia'] !== null || servico['s.distancia'] !== undefined)
									? (servico['s.distancia'].replace('.', ',') + 'km')
									: ('')
							}
							fill={true}
						/>
					</div>}

				{servico['s.dataHoraColetar'] && servico['s.dataHoraColetar'] != null
					? <div xs={12} sm={4}>
						<small>
							<div className="ps-0 m-0">
								<Status
									danger={urgente}
									texto={servico['s.dataHoraColetar'] === '0000-00-00 00:00:00'
										? 'AGORA'
										: Date.parse(servico['s.dataHoraColetar']) != NaN
											? format(new Date(servico['s.dataHoraColetar'].replace(/^0+/, '')), 'dd/MM HH:mm')
											: <small>{Date(servico['s.dataHoraColetar'])}</small>}
									fill={true}
									color={servico['s.dataHoraColetar'] != '0000-00-00 00:00:00' ? '#ed6c02' : null}
								/>
							</div>
						</small>
					</div>
					: <>
						{servico['s.horaColetado'] && servico['s.horaColetado'] != null
							? <div xs sm={4}>
								<small>
									<div className="ps-0 m-0">
										<Status
											danger={urgente}
											texto={new Date(servico['s.horaColetado']).toLocaleDateString()}
											fill={true}
										/>
									</div>
								</small>
							</div>
							: ''}
					</>
				}

				{servico['data']
					? <div>
						<small>
							<div className="ps-0 m-0">
								<Status
									danger={urgente}
									texto={new Date(servico['data']).toLocaleDateString()}
									fill={true}
								/>
							</div>
						</small>
					</div>
					: servico['s.dataFinalizacao'] && servico['s.dataFinalizacao'] != null
						? <div>
							<small>
								<div className="ps-0 m-0">
									<Status
										danger={urgente}
										texto={new Date(servico['s.dataFinalizacao']).toLocaleDateString()}
										fill={true}
									/>
								</div>
							</small>
						</div>
						: ''}

				{mostrarNomes == true && <>
					{servico["so.nome"] && servico["so.nome"] != "-" && <div className="truncate grid-item">
						<Status
							danger={urgente}
							texto={servico["so.nome"]}
							fill={true}
							color={corDinamica && servico["so.corCliente"]}
							truncate
							black={corDinamica}
							pop
						/>
					</div>}

					{servico["so.empresa"] && servico["so.empresa"] != "-" && <div className="grid-item">
						<Status
							danger={urgente}
							texto={servico["so.empresa"]}
							fill={true}
							color={corDinamica && servico["so.corCliente"]}
							truncate
							black={corDinamica}
							pop
						/>
					</div>}

					{servico["so.nomeFantasia"] && servico["so.nomeFantasia"] != "-" && <div className="truncate grid-item">
						<Status
							danger={urgente}
							texto={servico["so.nomeFantasia"]}
							fill={true}
							color={corDinamica && servico["so.corCliente"]}
							truncate
							black={corDinamica}
							pop
						/>
					</div>}
				</>}
			</GridInfos>}

			{servico["sa.direcao"] && servico["sa.direcao"] != "-" && <div className="mt-1">
				<Status
					danger={urgente}
					texto={servico["sa.direcao"]}
					fill={true}
					color={corDinamica && servico["so.corCliente"]}
					truncate
					black={corDinamica}
					pop
				/>
			</div>}
			{action && action}
		</div>
	</Card >
}

export function TimerColeta({ label, tempoInicial, tempoMax }) {
	const [tempo, setTempo] = useState(tempoInicial)

	useEffect(() => {
		if (tempo > 0) setTimeout(() => setTempo(p => p - 1), 1000)
	}, [tempo])

	const formatTime = (totalSeconds) => {
		const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
		const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
		const seconds = String(totalSeconds % 60).padStart(2, '0')
		return `${hours}:${minutes}:${seconds}`
	}

	return <div style={{
		animation: "pulse 1s infinite",
		fontWeight: 800
	}}>
		<div style={{
			display: "flex",
			justifyContent: "right",
			borderRadius: "8px",
			boxShadow: "inset 0 0 6px -3px #0003"
		}}>
			<div style={{
				width: `${(tempo / tempoMax) * 100}%`,
				height: "12px",
				background: "var(--primaria)",
				borderRadius: "8px"
			}} />
		</div>
		<div className="flex justify-between">
			<div>{label}</div>
			<div>{formatTime(tempo)}</div>
		</div>
	</div>
}